import { useEffect } from "react";
import { marked } from "marked";
import DOMPurify from "dompurify";
import hljs from "highlight.js";
import "highlight.js/styles/github-dark.css";

// decode HTML entities
const decodeEntities = (str) => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = str;
  return textarea.value;
};

// renderer setup
const renderer = new marked.Renderer();

renderer.code = (code, language) => {
  const validLang =
    language && hljs.getLanguage(language) ? language : "plaintext";
  const highlighted = hljs.highlight(code, { language: validLang }).value;

  return `
    <div class="code-block">
      <button class="copy-btn" type="button">📋 Copy</button>
      <pre><code class="hljs language-${validLang}">${highlighted}</code></pre>
    </div>
  `;
};

renderer.codespan = (code) => `<code class="inline-code">${code}</code>`;

marked.setOptions({ renderer, gfm: true, breaks: true });

export default function MarkdownRenderer({ content }) {
  // copy button listener
  useEffect(() => {
    const container = document.querySelector(".singlePostDesc");
    if (!container) return;

    const handleClick = (e) => {
      const btn = e.target.closest(".copy-btn");
      if (!btn) return;

      const codeEl = btn.parentElement.querySelector("pre code");
      if (!codeEl) return;

      navigator.clipboard.writeText(codeEl.innerText).then(() => {
        const msg = document.createElement("span");
        msg.innerText = "Copied!";
        msg.className = "copy-success";
        btn.appendChild(msg);
        setTimeout(() => msg.remove(), 1500);
      });
    };

    container.addEventListener("click", handleClick);
    return () => container.removeEventListener("click", handleClick);
  }, [content]);

  return (
    <div
      className="singlePostDesc"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(marked.parse(decodeEntities(content))),
      }}
    />
  );
}

